import { lazy } from "react";
import Loadable from "components/Loadable";
import AuthGuard from "auth/AuthGuard";
import MatxLayout from "components/MatxLayout/MatxLayout";
import Redirect from "pages/redirect/Redirect";
import privateRoutes from "./private-routes";
import RedirectError from "pages/error/RedirectError";


const DashboardRedirect = Loadable(lazy(() => import("pages/redirect/DashboardRedirect")));
const Logout = Loadable(lazy(() => import("pages/redirect/Logout")));



const routes = [
  {
    element: (
      <AuthGuard >
        <MatxLayout />
      </AuthGuard>
    ),
    children: [...privateRoutes ]
  },

  // dashboard redirect 
  { path: "/dashboard/redirect", element: <DashboardRedirect /> },
  { path: "/logout", element: <Logout /> },


  { path: "/", element: <Redirect /> },
  { path: "/redirect", element: <RedirectError /> },

];

export default routes;
